import { h } from 'preact';

const Overlay = ({ isOpen, onClose }) => (
  <div
    className={`js-overlay fixed inset-0 z-50 bg-black opacity-25 transition-opacity duration-300 ${isOpen ? 'block' : 'hidden'}`}
    onClick={onClose}
  />
);

export default Overlay;
